import { render, staticRenderFns } from "./CompanyTransactionsHistory.vue?vue&type=template&id=34dfd0a6&scoped=true"
import script from "./CompanyTransactionsHistory.vue?vue&type=script&lang=js"
export * from "./CompanyTransactionsHistory.vue?vue&type=script&lang=js"
import style0 from "./CompanyTransactionsHistory.vue?vue&type=style&index=0&id=34dfd0a6&prod&lang=scss&scoped=true"
import style1 from "./CompanyTransactionsHistory.vue?vue&type=style&index=1&id=34dfd0a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dfd0a6",
  null
  
)

export default component.exports